<ng-container *transloco="let t">
    <h4 class="mb-2" *ngrxLet="selectedTime$ as selectedTime">
        {{ t('today') + ', ' + (selectedTime | dfnsFormat : 'HH:mm') }}
    </h4>

    <div class="grid grid-cols-2 gap-2 w-max mx-auto mb-2">
        <div class="bg-gray-50 w-[8rem] rounded-lg mx-auto">
            <div cdkVirtualScrollingElement class="h-[176px]">
                <cdk-virtual-scroll-viewport [itemSize]="44" (scrolledIndexChange)="changeHour($event)" #hoursViewport>
                    <button
                        *cdkVirtualFor="let item of hours$ | async; let i = index"
                        tuiButton
                        size="m"
                        [appearance]="i === (selectedHourIndex$ | async) ? 'secondary' : 'custom'"
                        class="w-full"
                        (click)="selectedHourIndex$.next(i)"
                    >
                        {{ item }}
                    </button>
                </cdk-virtual-scroll-viewport>
                <div class="h-[132px]"></div>
            </div>
        </div>
        <div class="bg-gray-50 w-[8rem] rounded-lg mx-auto">
            <div cdkVirtualScrollingElement class="h-[176px]">
                <cdk-virtual-scroll-viewport
                    [itemSize]="44"
                    (scrolledIndexChange)="changeMinute($event)"
                    #minutesViewport
                >
                    <button
                        *cdkVirtualFor="let item of minutes$ | async; let i = index"
                        tuiButton
                        size="m"
                        [appearance]="i === (selectedMinuteIndex$ | async) ? 'secondary' : 'custom'"
                        class="w-full"
                        (click)="selectedMinuteIndex$.next(i)"
                    >
                        {{ item }}
                    </button>
                </cdk-virtual-scroll-viewport>
                <div class="h-[132px]"></div>
            </div>
        </div>
    </div>

    <div class="flex items-center justify-end">
        <button
            tuiButton
            appearance="primary"
            size="m"
            (click)="handleSubmit()"
            *ngrxLet="isValid$ as isValid"
            [disabled]="!isValid"
        >
            {{ t('accept') }}
        </button>
    </div>
</ng-container>
